import { render, staticRenderFns } from "./case-marker.vue?vue&type=template&id=24d9f03e&scoped=true"
import script from "./case-marker.vue?vue&type=script&lang=ts"
export * from "./case-marker.vue?vue&type=script&lang=ts"
import style0 from "./case-marker.vue?vue&type=style&index=0&id=24d9f03e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9f03e",
  null
  
)

export default component.exports